module.exports = { "default": require("core-js/library/fn/math/log2"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/log2.js
// module id = 825
// module chunks = 0